import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__ from "../useEventListener/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__useDocumentMutation_index_js_eb5fdfdf__ from "../useDocumentMutation/index.js";
function useElementDimensions(selector) {
    const [element, setElement] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(document.querySelector(selector));
    const [dimensions, setDimensions] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)({});
    const handleDocumentMutation = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>setElement(document.querySelector(selector)), [
        selector
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE__useDocumentMutation_index_js_eb5fdfdf__.useDocumentMutation)(handleDocumentMutation);
    const handleElementResize = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (element) {
            const { scrollHeight, clientHeight, scrollWidth, clientWidth } = element;
            const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();
            setDimensions({
                scrollHeight,
                clientHeight,
                scrollWidth,
                clientWidth,
                top,
                right,
                bottom,
                left,
                width,
                height,
                x,
                y
            });
        } else setDimensions({});
    }, [
        element
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__.useEventListener)('resize', handleElementResize);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(handleElementResize, [
        handleElementResize
    ]);
    return dimensions;
}
export { useElementDimensions };
